import React from 'react';

const Indian = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 225 150" {...props}>
      <rect fill="#f93" height="150" width="225" />
      <rect fill="#fff" height="50" width="225" y="50" />
      <rect fill="#128807" height="50" width="225" y="100" />
      <g transform="translate(112.5,75)">
        <circle fill="#008" r="20" />
        <circle fill="#fff" r="17.5" />
        <circle fill="#008" r="3.5" />
        <g id="india_d">
          <g id="india_c">
            <g id="india_b">
              <g id="india_a">
                <circle
                  fill="#008"
                  r="0.875"
                  transform="rotate(7.5) translate(17.5)"
                />
                <path
                  d="M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z"
                  fill="#008"
                />
              </g>
              <use transform="rotate(15)" xlinkHref="#india_a" />
            </g>
            <use transform="rotate(30)" xlinkHref="#india_b" />
          </g>
          <use transform="rotate(60)" xlinkHref="#india_c" />
        </g>
        <use transform="rotate(120)" xlinkHref="#india_d" />
        <use transform="rotate(-120)" xlinkHref="#india_d" />
      </g>
    </svg>
  );
};

export default Indian;
